export enum GoogleRecaptchaScriptEvent {
  load = 'load',
  ready = 'ready',
}
